import {KeyEventsDispatcher, KeyEventProcessor} from '../../../../helpers/KeyEventsDispatcher';

export function SetupEventMouse(panelId: string, emit: (eventName: string) => void) {
	const processor: KeyEventProcessor = {
		panelId,
		onKeypress: (event: KeyboardEvent) => false,
		onKeydown: (event: KeyboardEvent) => false,
		onKeyup: (event: KeyboardEvent) => false,
		emit,
	};

	function on_pointer_move(event: MouseEvent) {
		KeyEventsDispatcher.instance().registerProcessor(processor);
	}

	return {
		on_pointer_move,
	};
}
